// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modal_backdrop__1mf1y","modalContainer":"Modal_modalContainer__28A7L","modal":"Modal_modal__1vwov","link":"Modal_link__21iYV"};